"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
require("../../../../../../components");
const constants_1 = require("../../../constants");
const addToPolicyResultCellRenderer_1 = require("./addToPolicyResultCellRenderer");
const getColumns = (texts) => {
    return [
        {
            field: constants_1.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS.instanceName,
            title: texts.resourceName,
            minWidth: 100,
            width: 150,
        },
        {
            field: constants_1.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS.id,
            title: texts.id,
            minWidth: 100,
            width: 140,
        },
        {
            field: constants_1.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS.policyName,
            title: texts.policyName,
            minWidth: 100,
            width: 150,
        },
        {
            field: constants_1.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS.result,
            title: texts.result,
            cell: addToPolicyResultCellRenderer_1.addToPolicyResultCellRenderer(),
        },
    ];
};
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map